import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT, MAX_ITEMS_IN_PAGE } from '../commonActions';
import { formatDate } from '../../../common/Utilities';
import moment from 'moment';

const SET_HOLIDAY_FIELD_CHANGE = 'SET_HOLIDAY_FIELD_CHANGE';
const FETCH_HOLIDAYS = 'FETCH_HOLIDAYS';
const SET_HOLIDAY = 'SET_HOLIDAY';
const RESET_HOLIDAY = 'RESET_HOLIDAY';
const HOLIDAY_FILTER = 'HOLIDAY_FILTER';

export const SET_HOLIDAYS_PAGINATION = 'SET_HOLIDAYS_PAGINATION';
export const RESET_HOLIDAYS_PAGINATION = 'RESET_HOLIDAYS_PAGINATION';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const upsertHoliday = (action, successCallback = null) => {
  return (dispatch, getState) => {
    const holiday = getState().holidays.holiday;

    if (typeof(holiday.date) !== 'undefined') {
      //change date format
      Object.assign(holiday, {date: formatDate(new Date(holiday.date))});
    }

    let endpoint = '/holidays/create';
    let message = 'Holiday has been successfully created.';

    if (action === 'UPDATE_HOLIDAY') {
      endpoint = '/holidays/update';
      message = 'Holiday has been successfully updated.';
    }

    client().post(
      endpoint, 
      holiday 
    ).then(json => {
      const result = json.data;

      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
        if (successCallback) {
          successCallback();
        }
        
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const handleFieldChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value = {}
    if (!definedValue) {
      const id = e.target.id;
  
      value = {
        [id]: e.target.value
      }
    }
    else {
      value = definedValue;
    }

    dispatch({type: SET_HOLIDAY_FIELD_CHANGE, value})
  }
}


export const fetchHolidays = () => {
  return (dispatch, getState) => {
    client().get(
      'holidays/list'
    ).then(json => {
      const result = json.data;
      if (result) {
        let holidays = result.data;
        
        if (!holidays.length) {
          holidays = null;
        }
        else {
          let numItems = holidays.length;
          let min = getState().holidays.min;
          let max = numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().holidays.max;
          
          const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);
          
          dispatch({type: SET_HOLIDAYS_PAGINATION, numItems, min, max, totalPages});
        }
        dispatch({type: FETCH_HOLIDAYS, holidays})
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const getHoliday = (id) => {
  return (dispatch) => {
    client().get(
      'holidays/get', {
        params: {
          id
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let holiday = result.data;
        dispatch({type: SET_HOLIDAY, holiday})
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const resetHoliday = () => {
  return (dispatch) => {
    dispatch({type: RESET_HOLIDAY});
  }
}

export const deleteHoliday = (id) => {
  return (dispatch) => {
    client().get(
      'holidays/delete', {
        params: {
          id
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Holiday has been successfully deleted."));
        dispatch(fetchHolidays());
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const filterHolidays = (filter) => {
  return (dispatch) => {
    dispatch({type: HOLIDAY_FILTER, filter});
  }
}

export const isHoliday = (date) => {

  return (dispatch, getState) => {
    const holidays = getState().holidays.holidays;

    return !!holidays.filter(holiday => moment(holiday.date).isSame(date)).length;
  }
}